<template>
    <button
        type="button"
        class="attachment-thumbnail"
        :aria-label="error ? `Riprova miniatura di ${attachment.filename}` : `Ingrandisci anteprima di ${attachment.filename}`"
        @click="handleClick"
    >
        <v-progress-circular v-if="loading" indeterminate color="primary" size="28" width="3" />
        <img v-else-if="previewUrl" :src="previewUrl" alt="" class="attachment-thumbnail__image" />
        <div v-else class="attachment-thumbnail__fallback">
            <v-icon color="grey lighten-1">{{ fallbackIcon }}</v-icon>
            <span>{{ error || "Miniatura non disponibile" }}</span>
            <span v-if="error" class="attachment-thumbnail__retry">
                <v-icon x-small>mdi-refresh</v-icon> Riprova
            </span>
        </div>
        <span class="attachment-thumbnail__banner">PEZZO NON CONFORME</span>
    </button>
</template>

<script>
export default {
    name: "MailAttachmentThumbnail",
    props: {
        messageUid: { type: [String, Number], required: true },
        attachment: { type: Object, required: true },
    },
    data: () => ({
        loading: false,
        error: "",
        previewUrl: "",
    }),
    computed: {
        thumbnailKey() {
            return `${this.messageUid}:${this.attachment.id}`;
        },
        fallbackIcon() {
            return this.attachment.content_type === "application/pdf"
                ? "mdi-file-pdf-box"
                : "mdi-file-image-outline";
        },
    },
    watch: {
        thumbnailKey: {
            immediate: true,
            handler() {
                this.loadThumbnail();
            },
        },
    },
    beforeDestroy() {
        this.releaseThumbnail();
    },
    methods: {
        handleClick() {
            if (this.error) this.loadThumbnail();
            else this.$emit("open");
        },
        async loadThumbnail() {
            const requestedKey = this.thumbnailKey;
            this.releaseThumbnail();
            this.error = "";
            if (String(this.messageUid).startsWith("demo-")) {
                this.error = "Disponibile con una mail reale";
                return;
            }

            this.loading = true;
            try {
                const response = await this.$work.get(
                    `/qualita/mail-segnalazioni/${encodeURIComponent(this.messageUid)}/allegati/${encodeURIComponent(this.attachment.id)}/`,
                    { thumbnail: true },
                    true,
                    null,
                    { responseType: "blob" }
                );
                const url = URL.createObjectURL(response.data);
                if (requestedKey !== this.thumbnailKey) {
                    URL.revokeObjectURL(url);
                    return;
                }
                this.previewUrl = url;
            } catch (_error) {
                if (requestedKey === this.thumbnailKey) this.error = "Anteprima non disponibile";
            } finally {
                if (requestedKey === this.thumbnailKey) this.loading = false;
            }
        },
        releaseThumbnail() {
            if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
            this.previewUrl = "";
        },
    },
};
</script>

<style scoped>
.attachment-thumbnail {
    position: relative;
    display: grid;
    width: 100%;
    height: clamp(240px, 28vw, 360px);
    margin-top: 14px;
    padding: 0;
    place-items: center;
    overflow: hidden;
    border: 1px solid rgba(127, 127, 127, 0.35);
    border-radius: 4px;
    background: rgba(38, 50, 56, 0.08);
    cursor: zoom-in;
}
.attachment-thumbnail:focus-visible { outline: 3px solid var(--v-primary-base); outline-offset: 2px; }
.attachment-thumbnail__image { width: 100%; height: 100%; object-fit: contain; background: white; }
.attachment-thumbnail__fallback { display: flex; flex-direction: column; align-items: center; gap: 6px; color: #757575; font-size: 0.75rem; }
.attachment-thumbnail__retry { padding: 4px 8px; color: var(--v-primary-base); font-weight: 600; }
.attachment-thumbnail__banner {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 6px 8px;
    color: white;
    background: rgba(183, 28, 28, 0.94);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.07em;
    line-height: 1.2;
    text-align: center;
}

@media (max-width: 600px) {
    .attachment-thumbnail { height: 220px; }
}
</style>
